import { ReactComponent as CharityDark } from "./charity-dark-icon.svg";

const CharityDarkIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <CharityDark {...props} />;

export default CharityDarkIcon;
